import {
  Outlet,
  createFileRoute,
  redirect,
  stripSearchParams,
  useRouterState,
} from "@tanstack/react-router";
import * as z from "zod/v4";
import { zodValidator } from "@tanstack/zod-adapter";
import { LoadingSpinner } from "@/components/loading";
import { isLoggedIn } from "@/lib/http";

const authLayoutSearchSchema = z.object({
  redirect: z.string().optional(),
  redirectSearch: z.record(z.string().min(1), z.any()).optional(),
});

export const Route = createFileRoute("/auth")({
  validateSearch: zodValidator(authLayoutSearchSchema),
  search: {
    middlewares: [
      stripSearchParams({
        redirect: "/",
        redirectSearch: {},
      }),
    ],
  },
  beforeLoad({ search: { redirect: redirectPath, redirectSearch }, location }) {
    if (
      location.pathname === "/auth/verify" ||
      location.pathname === "/auth/verify-code"
    )
      return;

    if (isLoggedIn()) {
      throw redirect({
        to: redirectPath ?? "/",
        search: redirectSearch,
      });
    }
  },
  pendingComponent: () => (
    <div className="flex h-screen w-screen grow items-center justify-center">
      <LoadingSpinner size={48} />
    </div>
  ),
  component: AuthLayout,
});

const FULL_BLEED_AUTH_PATHS = new Set([
  "/auth/login",
  "/auth/signup",
  "/auth/verify",
  "/auth/verify-code",
  "/auth/guest-signup",
]);

function AuthLayout() {
  const isFullBleed = useRouterState({
    select: (s) => {
      const leafMatch = s.matches.at(-1);
      return leafMatch ? FULL_BLEED_AUTH_PATHS.has(leafMatch.pathname) : false;
    },
  });

  if (isFullBleed) {
    return <Outlet />;
  }

  return (
    <div className="flex flex-1 flex-col py-4">
      <div className="mt-8 mb-8">
        <Outlet />
      </div>
    </div>
  );
}
